import { IAppUser } from "./types";

export const UNAUTHORIZED_ADMIN_ACCESS = "UNAUTHORIZED_ADMIN_ACCESS";

export const canAccessAdminCenter = (user?: IAppUser | null): boolean => {
  if (!user) {
    return false;
  }

  if (user.isSystemAdmin) {
    return true;
  }

  return (user.memberships ?? []).some(
    (membership) =>
      membership.orgUser &&
      ["ORG_ADMIN", "ADMIN"].includes(membership.orgUser.role)
  );
};

export const clearPortalSession = (): void => {
  localStorage.removeItem("tokenType");
  localStorage.removeItem("accessToken");
  localStorage.removeItem("refreshToken");
  sessionStorage.removeItem("selectedOrganization");
};
